import { flatten, isEmpty } from 'lodash-es';
import { parse } from 'query-string';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { getContactsCollection, getContactsCounts } from '@/store/contacts/actions';

export const useContactsCount = (): number => {
    const location = useLocation();
    const { statuses: queryStatuses = [] } = parse(location.search, { arrayFormat: 'comma' });
    const collection = useSelector(getContactsCollection);
    const counts = useSelector(getContactsCounts);
    const statuses = flatten([queryStatuses]);

    if (!counts) {
        return null;
    }
    // this should return 0 cause sometimes after deleting contacts, we have no collection but the total count was not cleared
    if (counts.totalCount && isEmpty(collection)) {
        return 0;
    }
    if (!isEmpty(statuses)) {
        return statuses?.reduce((acc, singleStatus): number => {
            const givenCount = Object.keys(counts)?.find((key): boolean =>
                key?.startsWith(singleStatus?.toLowerCase())
            );

            return +acc + (counts?.[givenCount] || 0);
        }, 0);
    }

    return counts?.totalCount || 0;
};
